export * from './components/CopilotMessageFooter/index';
//# sourceMappingURL=CopilotMessageFooter.js.map